// extracted by mini-css-extract-plugin
export default {"buttons-container":"Select_buttons-container__Hgy7V","align-center":"Select_align-center__s83Sk","inputLabel":"Select_inputLabel__nMxhn","input":"Select_input__eExKU"};